// Python highlighting for showing a program: a small tokeniser rather than the editor,
// which is a 150 KB bundle nobody needs to read a page of code. Comments, strings
// (including triple-quoted ones spanning lines), numbers, keywords, decorators and the
// names of defs and classes; everything else is plain.

import { el } from "./dom.js";

const KEYWORDS = new Set(("False None True and as assert async await break class continue def del elif else except " +
  "finally for from global if import in is lambda nonlocal not or pass raise return try while with yield").split(" "));
const BUILTINS = new Set("print len range int float str list dict tuple set min max sum abs zip enumerate isinstance super".split(" "));

const TOKEN = /(#[^\n]*)|("""[\s\S]*?"""|'''[\s\S]*?''')|([rRbBuUfF]{0,2}(?:"(?:\\.|[^"\\\n])*"|'(?:\\.|[^'\\\n])*'))|(@[\w.]+)|(\b\d[\w.]*\b)|(\b[A-Za-z_]\w*\b)|([\s\S])/g;

export function highlightPython(text) {
  const frag = document.createDocumentFragment();
  let plain = "";
  const flush = () => { if (plain) { frag.appendChild(document.createTextNode(plain)); plain = ""; } };
  let prev = "";
  for (const m of text.matchAll(TOKEN)) {
    const [tok, com, tstr, str, dec, num, word] = m;
    let cls = null;
    if (com) cls = "hl-com";
    else if (tstr || str) cls = "hl-str";
    else if (dec) cls = "hl-dec";
    else if (num) cls = "hl-num";
    else if (word) {
      if (KEYWORDS.has(word)) cls = "hl-kw";
      else if (prev === "def" || prev === "class") cls = "hl-def";
      else if (BUILTINS.has(word)) cls = "hl-bi";
    }
    if (cls) { flush(); frag.appendChild(el("span", cls, tok)); } else plain += tok;
    if (word) prev = word; else if (tok.trim()) prev = "";
  }
  flush();
  return frag;
}
